import { http } from "../api";
const easyUnpack = ({ data }) => data;
export const LassieScenarioApi = {
  create_lassie_scenario: {
    f: function create_lassie_scenario(windfarm_id, title, { immediate_action = null, description = null }) {
      let url = '/lassie/scenario';
      return http.post(url, { windfarm_id, title, immediate_action, description }).then(easyUnpack)
    }
  },
  list_scenarios: {
    f: function list_scenarios(windfarm_id) {
      let url = '/lassie/scenario/windfarm/$windfarm_id';
      let parameterNames = ["$windfarm_id"];[windfarm_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
      return http.get(url, { params: {} }).then(easyUnpack)
    }
  },
  scenarios_overview: {
    f: function scenarios_overview() {
      let url = '/lassie/scenario/windfarms/overview';
      return http.get(url, { params: {} }).then(easyUnpack)
    }
  },
  base_view: {
    f: function base_view(frequency, scenario_id) {
      let url = "/lassie/scenario/$scenario_id/subscribe/$frequency";
      let parameterNames = ["$frequency", "$scenario_id"];
      [frequency, scenario_id].forEach((parameterValue, index) => {
        url = url.replace(parameterNames[index], parameterValue);
      });
      return http.post(url, {}).then(easyUnpack);
    },
  },
  create_scenario_user_subscription: {
    f: function create_scenario_user_subscription(scenario_id, frequency, { target_user_id = null }) {
      let url = '/lassie/scenario/$scenario_id/subscribe/user/$target_user_id/frequency/$frequency';
      let parameterNames = ["$scenario_id", "$target_user_id", "$frequency"];
      [scenario_id, target_user_id, frequency].forEach((parameterValue, index) => {
        url = url.replace(parameterNames[index], parameterValue)
      })
      return http.post(url, { frequency }).then(easyUnpack)
    }
  },
  delete_user_subscription: {
    f: function delete_user_subscription(frequency, scenario_id) {
      let url = "/lassie/scenario/$scenario_id/subscribe/$frequency";
      let parameterNames = ["$frequency", "$scenario_id"];
      [frequency, scenario_id].forEach((parameterValue, index) => {
        url = url.replace(parameterNames[index], parameterValue);
      });
      return http.delete(url, { data: {} }).then(easyUnpack);
    }
  },
  delete_scenario_user_subscription: {
    f: function delete_scenario_user_subscription(scenario_id, frequency, { target_user_id = null }) {
      let url = '/lassie/scenario/$scenario_id/subscribe/user/$target_user_id/frequency/$frequency';
      let parameterNames = ["$scenario_id", "$target_user_id", "$frequency"];
      [scenario_id, target_user_id, frequency].forEach((parameterValue, index) => {
        url = url.replace(parameterNames[index], parameterValue)
      })
      return http.delete(url, { data: {} }).then(easyUnpack)
    }
  },
  update_template_id: {
    f: function update_template_id(scenario_id, { template_id = null }) {
      let url = '/lassie/scenario/$scenario_id';
      let parameterNames = ["$scenario_id"];[scenario_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
      return http.patch(url, { template_id }).then(easyUnpack)
    }
  },
  update_scenario: {
    f: function update_scenario(scenario_id, title, description) {
      let url = '/lassie/scenario/$scenario_id/edit';
      let parameterNames = ["$scenario_id"];[scenario_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
      return http.patch(url, { title, description }).then(easyUnpack)
    }
  },
  deactivate_scenario: {
    f: function deactivate_scenario(scenario_id) {
      let url = '/lassie/scenario/$scenario_id/deactivate';
      let parameterNames = ["$scenario_id"];[scenario_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
      return http.patch(url, {}).then(easyUnpack)
    }
  },
  copy_windfarm_settings: {
    f: function copy_windfarm_settings(source_windfarm_id, target_windfarms) {
      let url = '/lassie/scenario/copy-settings';
      return http.post(url, { source_windfarm_id, target_windfarms }).then(easyUnpack)
    }
  },
};
